module.exports = __webpack_public_path__ + "img/order-here.37e491c7.gif";